import {MutationTree} from "vuex";
import {TradeContractFormatGroup, TradeContractFormatGroupState} from "./model";

const mutations: MutationTree<TradeContractFormatGroupState> = {
  setTradeContractFormatGroups(state, groups: TradeContractFormatGroup[]) {
    state.groups = groups;
  },
  addTradeContractFormatGroup(state, group: TradeContractFormatGroup) {
    state.groups.push(group);
  },
  updateTradeContractFormatGroup(state, group: TradeContractFormatGroup) {
    const pos = state.groups.findIndex(c => c.id === group.id);
    if(pos !== -1) {
      state.groups.splice(pos, 1, group);
    }
  },
  deleteTradeContractFormatGroup(state, id: string) {
    const pos = state.groups.findIndex(c => c.id === id);
    if(pos !== -1) {
      state.groups.splice(pos, 1);
    }
  }
}

export default mutations;
